import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import HinovaIntegration from './HinovaIntegration';
import SouthIntegration from './SouthIntegration';
import SouthV0Integration from './SouthV0Integration';
import EptaIntegration from './EptaIntegration';
import { Client } from '@/types/client';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

interface IntegrationTabProps {
  client: Client;
}

const IntegrationTab: React.FC<IntegrationTabProps> = ({ client }) => {
  // Determinar qual integração mostrar baseado no system_management
  const renderIntegration = () => {
    switch (client.system_management) {
      case 'hinova':
        return <HinovaIntegration client={client} />;
      
      case 'south':
        return <SouthIntegration client={client} />;
      
      case 'south-v0':
        return <SouthV0Integration client={client} />;

      case 'epta':
        return <EptaIntegration client={client} />;

      case 'siprove':
        return (
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <AlertTriangle className="w-5 h-5 text-yellow-600" />
                Sistema {client.system_management?.toUpperCase()} - Em Desenvolvimento
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">
                A integração com o sistema <strong>{client.system_management?.toUpperCase()}</strong> está em desenvolvimento.
                Entre em contato com o suporte para mais informações.
              </p>
            </CardContent>
          </Card>
        );
      
      default:
        return (
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <AlertTriangle className="w-5 h-5 text-gray-600" />
                Sistema de Gestão Não Configurado
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <p className="text-gray-600">
                  Nenhum sistema de gestão foi configurado para este cliente.
                </p>
                <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                  <h4 className="font-medium text-blue-900 mb-2">Para configurar a integração:</h4>
                  <ol className="list-decimal list-inside space-y-1 text-blue-800 text-sm">
                    <li>Vá para a <strong>tela de cadastro do cliente</strong></li>
                    <li>No campo <strong>"Sistema de Gestão"</strong>, selecione:</li>
                    <ul className="list-disc list-inside ml-4 mt-1">
                      <li><strong>Hinova</strong> - Para sistema SGA Hinova</li>
                      <li><strong>South</strong> - Para sistema South</li>
                      <li><strong>South V0</strong> - Para sistema South V0 (nova versão)</li>
                      <li><strong>Epta</strong> - Para sistema Epta</li>
                      <li><strong>Siprove</strong> - Em desenvolvimento</li>
                    </ul>
                    <li>Salve as alterações</li>
                    <li>Retorne a esta tela para configurar a integração</li>
                  </ol>
                </div>
              </div>
            </CardContent>
          </Card>
        );
    }
  };

  return (
    <div className="space-y-6">
      {renderIntegration()}
    </div>
  );
};

export default IntegrationTab;
